import { getGlobalHeadersAsObject } from "../global-headers";

export interface Group {
	id: number;
	name: string;
	group_id: number | null;
	url: string | null;
	members: number | null;
}

export interface GroupsResponse {
	results: Group[];
}

export const fetchPersonGroups = (personId: number): Promise<GroupsResponse> => {
	if (!personId || typeof personId !== "number") {
		throw new Error(
			`fetchPersonGroups called with invalid argument personId '${personId}'. Expected number`
		);
	}

	const url = new URL(`/api/v2/persons/${personId}/groups/`, window.location.origin);

	return fetch(url.toString(), {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => {
		if (!res.ok) {
			throw new Error(`Failed to fetch person groups: ${res.statusText}`);
		}
		return res.json();
	});
};
